import { Link } from 'react-router-dom'

// Router migration adapter:
// Keep link import centralized for consistent usage across app code.
export default Link
